export default __webpack_public_path__ + "static/media/gallery-wip-emitter_14.6c075594.jpg";